module.exports = __webpack_public_path__ + "img/timer.f4e84c54.svg";